import { Observable } from "rxjs";
import { RespInterface } from "@common/ports/interfaces/respt.interface";
import { RespListInterface } from "@common/ports/interfaces";
import { PortfolioInterface } from "../interfaces";

export abstract class PortfolioAbstraction {
  abstract list(query: string): Observable<RespListInterface<PortfolioInterface>>
  abstract create(portfolio: PortfolioInterface): Observable<RespInterface<PortfolioInterface>>;
  abstract read(id: string): Observable<RespInterface<PortfolioInterface>>;
  abstract update(portfolio: PortfolioInterface): Observable<RespInterface<string>>;
  abstract delete(id: string): Observable<RespInterface<PortfolioInterface>>;
  //Client
  abstract listPortfolioClient(): Observable<RespListInterface<PortfolioInterface>>
}
